import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../../../Common/PlaceholderWrapper";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import PopupWrapper from "../../../Common/PopupWrapper";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";
import textUtils from "@mnjsplatform/data/lib/utils/textUtils";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";
import i18next from "i18next";

class ScheduleChangeRequestEdit extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedTabNums: [], errorText: ""
        }
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.dataItem.reset());
            await this.props.dispatch(this.props.addDataItem.reset());

            await this.props.dispatch(this.props.dataItem.initialize({}, {
                newItem: true, withParams: true
            }));
            await this.props.dispatch(this.props.addDataItem.initialize(this.props.rowKey, {
                newItem: true, withParams: true, refresh: false
            }));
        } catch (e) {
            console.error(e);
        }
    };

    save = async () => {
        if (this.state.selectedTabNums.length > 0) {
            try {
                await this.props.dispatch(this.props.addDataItemParams.setField(0, "ListPers", this.state.selectedTabNums.join("\\")));
                await this.props.dispatch(this.props.addDataItem.applyParams(this.props.addDataItemParams));
                if (!this.props.addDataItem.isError) {
                    this.props.onClose();
                    this.props.afterSave();
                }
            } catch (e) {
                console.error(e);
            }
        } else {
            this.setState({errorText: i18next.t("SelectSubordinates")})
        }
    };

    onPersonClick = (rowIndex, row, e) => {
        this.setState((state, props) => {
            let newSelectedTabNums;
            if (row.IsChecked === 0) {
                newSelectedTabNums = state.selectedTabNums.filter(tn => true);
                newSelectedTabNums.push(row.TabNum);
            } else {
                newSelectedTabNums = state.selectedTabNums.filter(tn => tn !== row.TabNum);
            }
            return {
                selectedTabNums: newSelectedTabNums
            };
        });
    };

    afterApplyFilter = () => {
        if (this.props.dataItem.isInitialized && this.state.selectedTabNums.length > 0 && this.state.selectedTabNums.some(tn => !this.props.dataItem.dataTable().some(r => r.TabNum === tn))) {
            this.setState({selectedTabNums: []});
        }
    };

    gridRowStyleProvider = (rowIndex, row) => {
        let style = {cursor: "pointer"};
        if (row.IsChecked) {
            return {
                ...style, fontWeight: "bold", backgroundColor: "lightgrey"
            };
        }
        return style;
    };

    renderFilterParams = (h) => {
        return (<>
                <div className="row mb-2">
                    <div className="col-md-4">
                        {h.lbl("NumSub")}
                    </div>
                    <div className="col-md-1">
                        {h.ed("NumSub")}
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-12">
                        {h.ed("AdmStructName")}
                    </div>
                </div>

                <div className="row mb-2">
                    <div className="col-md-4">
                        {i18next.t("SubordinateSearch")}:
                    </div>
                    <div className="col-md-8" style={{height: "32px"}}>
                        <SearchBar dataItem={this.props.dataItem}
                                   afterApplyValue={this.afterApplyFilter}
                        />
                    </div>
                </div>
            </>);
    };

    renderFormParams = (h) => {
        return (<>
                <div className="row mb-2">
                    <div className="col-md-2">
                        {h.lbl("DateBegin")}
                    </div>
                    <div className="col-md-2">
                        {h.ed("DateBegin")}
                    </div>

                    <div className="col-md-2">
                        {h.lbl("DateEnd")}
                    </div>
                    <div className="col-md-2">
                        {h.ed("DateEnd")}
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-2">
                        {h.lbl("TypeTabCalTitle")}
                    </div>
                    <div className="col-md-6">
                        {h.ed("TypeTabCalTitle")}
                    </div>
                </div>
            </>);
    };

    renderGridRow = (row, rowIndex, renderRowDefault) => {
        let rRow = {
            ...row, IsChecked: this.state.selectedTabNums.some(tn => tn === row.TabNum) ? 1 : 0
        };
        return renderRowDefault(rRow, rowIndex);
    };

    renderGridCell = (row, fieldInfo, fieldIndex, renderCellDefault) => {
        if (fieldInfo.Name === "IsChecked") {
            return <input type="checkbox" className="checkbox" checked={row.IsChecked} style={{cursor: "pointer"}}
                          onChange={() => {
                          }}/>;
        } else {
            return renderCellDefault(row, fieldInfo, fieldIndex);
        }
    };

    renderButtons = () => {
        return (<div className="modal-footer text-right">
                <button type="button" className="btn btn-regular -goahead"
                        onClick={this.save}>{i18next.t("SaveSelection")}</button>
                <button type="button" className="btn btn-regular -default" data-dismiss="modal"
                        onClick={this.props.onClose}>{i18next.t("CloseWithoutSaving")}</button>
            </div>);
    };

    render() {
        let cnt = this.props.dataItem.rowsCount();
        let gridTitleText = i18next.t("ScheduleChangeRequestEdit_GridTitle", {people_count: textUtils.pluralize_i18next(cnt, "peopleCountPostfix")});

        return (<>
                <PopupWrapper popupVisible={true} title={i18next.t("ScheduleChangeRequestEdit_Title")}
                              instructionId="ScheduleChangeRequestEdit"
                              onClose={this.props.onClose} renderButtons={this.renderButtons}>
                    <PlaceholderWrapper placeholderId="ScheduleChangeRequestEdit_10" collapsed={false} showSplitterLine={false}
                                        canCollapse={false}
                                        title={<><i className='fa fa-filter'/> {i18next.t('Filters')}</>}
                                        staticTitle={`${i18next.t("ScheduleChangeRequestEdit_Title")} - ${i18next.t("Filters")}`}
                    >
                        <ComplexParam dataItem={this.props.dataItemParams}
                                      autoApplyParams={true}
                                      showApplyButton={false}
                                      showSearchBar={false}
                                      renderParams={this.renderFilterParams}
                                      rootPath={"/"}
                                      parentDataItem={this.props.dataItem}
                                      afterApplyParams={this.afterApplyFilter}
                        />
                    </PlaceholderWrapper>

                    <PlaceholderWrapper placeholderId="ScheduleChangeRequestEdit_20" collapsed={false} showSplitterLine={false}
                                        canCollapse={false}
                                        title={<><i className="fa fa-vcard"/> {i18next.t("DefaultValues")}</>}
                                        staticTitle={`${i18next.t("ScheduleChangeRequestEdit_Title")} - ${i18next.t("DefaultValues")?.toLocaleLowerCase()}`}
                    >
                        <ComplexParam dataItem={this.props.addDataItemParams}
                                      showApplyButton={false}
                                      showSearchBar={false}
                                      autoApplyParams={false}
                                      renderParams={this.renderFormParams}
                        />
                    </PlaceholderWrapper>

                    <PlaceholderWrapper placeholderId="ScheduleChangeRequestEdit_30" collapsed={false} showSplitterLine={false}
                                        canCollapse={false}
                                        title={<><i className='fa fa-table'/> {gridTitleText}</>}
                                        staticTitle={i18next.t("ScheduleChangeRequestEdit_GridTitle", {people_count: ''})}
                    >
                        <GridView dataItem={this.props.dataItem}
                                  allowPagination={true}
                                  readOnly={true}
                                  updateStateFlag={{f: this.state.selectedTabNums}}
                                  rowStyleProvider={this.gridRowStyleProvider}
                                  onRowClick={this.onPersonClick}
                                  renderRow={this.renderGridRow}
                                  renderCell={this.renderGridCell}
                        />
                    </PlaceholderWrapper>

                    <MessageBox title={i18next.t('Error')}
                                messageText={this.state.errorText}
                                visible={!!this.state.errorText}
                                onClose={() => {
                                    this.setState({errorText: ""})
                                }}
                    />
                </PopupWrapper>
            </>);
    }
}

ScheduleChangeRequestEdit.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    dataItemParams: PropTypes.object,
    addDataItem: PropTypes.object,
    addDataItemParams: PropTypes.object,
    rowKey: PropTypes.object.isRequired,
    afterSave: PropTypes.func,
    onClose: PropTypes.func
};

ScheduleChangeRequestEdit.defaultProps = {
    afterSave: () => {
    }, onClose: () => {
    }
};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: state.subScheduleChangeState.VacancyCmdChTabCal_PO_ListSub,
        dataItemParams: state.subScheduleChangeState.VacancyCmdChTabCal_PO_ListSubParams,
        addDataItem: state.subScheduleChangeState.VacancyCmdChTabCalPers_PO_AddList,
        addDataItemParams: state.subScheduleChangeState.VacancyCmdChTabCalPers_PO_AddListParams
    }
}

export default connect(mapStateToProps)(ScheduleChangeRequestEdit);